import React from 'react';
import { Box, Typography } from '@mui/material';
import BoothDetailPanel      from './BoothDetailPanel';
import BoothMediaDetailPanel from './BoothMediaDetailPanel';
import PortalDetailPanel     from './PortalDetailPanel';
import CustomBoothItemDetailPanel from './CustomBoothItemDetailPanel';
import CharityDetailPanel    from './CharityDetailPanel';
import HostingDetailPanel    from './HostingDetailPanel';
import EventDetailPanel      from './EventDetailPanel';
import AdvertiserDetailPanel from './AdvertiserDetailPanel';
import CampaignDetailPanel   from './CampaignDetailPanel';
import ItemDetailPanel       from './ItemDetailPanel';
import DiscountDetailPanel   from './DiscountDetailPanel';
import AdDetailPanel              from './AdDetailPanel';
import TeleportButtonDetailPanel  from './TeleportButtonDetailPanel';
import RecognitionDetailPanel     from './RecognitionDetailPanel';
import FreeTrialSettingDetailPanel from './FreeTrialSettingDetailPanel';
import FreeTrialItemDetailPanel    from './FreeTrialItemDetailPanel';
import PackageDetailPanel          from './PackageDetailPanel';
import PackageItemDetailPanel      from './PackageItemDetailPanel';
import QuizDetailPanel             from './QuizDetailPanel';

const PANELS = {
  booth:            BoothDetailPanel,
  booth_media:      BoothMediaDetailPanel,
  portal:           PortalDetailPanel,
  custom_booth_item: CustomBoothItemDetailPanel,
  charity:          CharityDetailPanel,
  hosting:          HostingDetailPanel,
  event:            EventDetailPanel,
  advertiser:       AdvertiserDetailPanel,
  campaign:         CampaignDetailPanel,
  item:             ItemDetailPanel,
  discount:         DiscountDetailPanel,
  ad:               AdDetailPanel,
  teleport_button:  TeleportButtonDetailPanel,
  recognition:      RecognitionDetailPanel,
  free_trial_setting: FreeTrialSettingDetailPanel,
  free_trial_item:    FreeTrialItemDetailPanel,
  package:            PackageDetailPanel,
  package_item:       PackageItemDetailPanel,
  game_schedule:      QuizDetailPanel,
};

// `lookups` (currencies, tax categories, ...) is optional — only the panels that format money read it.
export default function ContentDetailPanel({ contentType, data, diffKeys, side, lookups }) {
  const Panel = PANELS[contentType?.toLowerCase()];

  if (!Panel) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">
          No preview available for content type "{contentType}".
        </Typography>
      </Box>
    );
  }

  if (!data) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">
          No data available.
        </Typography>
      </Box>
    );
  }

  return <Panel data={data} diffKeys={diffKeys ?? new Set()} side={side ?? 'proposed'} lookups={lookups} />;
}
